import { useModal, create, show } from "@ebay/nice-modal-react";

import Banner from "ds/components/Banner";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";
import useDeleteIntentProject from "shared/IntentProject/useDeleteIntentProject";
import useSearchIntentResourcesSuggestions from "shared/IntentProject/useSearchIntentResourcesSuggestions";

type IntentProjectDeleteConfirmationProps = {
  id: string;
  name: string;
};

const IntentProjectDeleteConfirmation = create(function IntentProjectDeleteConfirmation({
  id,
  name,
}: IntentProjectDeleteConfirmationProps) {
  const { deleteIntentProject, loading } = useDeleteIntentProject();
  const { allResourcesCount, loading: countLoading } = useSearchIntentResourcesSuggestions(id);
  const modal = useModal();

  const hasResources = allResourcesCount > 0;
  const keepResources = hasResources || undefined;

  const handleConfirm = () => {
    deleteIntentProject(id, keepResources, () => {
      modal.resolve(id);
      modal.hide();
    });
  };

  return (
    <DeleteConfirmationModal
      title="Delete Intent Project"
      onConfirm={handleConfirm}
      isLoading={loading}
      isConfirmationDisabled={countLoading}
      isDismissable={!loading}
    >
      <ConfirmationModalMessage>
        Are you sure you want to delete <strong>{name}</strong>?
      </ConfirmationModalMessage>
      <br />
      {hasResources && (
        <Banner variant="warning" fullWidth>
          This Intent Project has{" "}
          <strong>
            {allResourcesCount} tracked {allResourcesCount === 1 ? "resource" : "resources"}
          </strong>
          . Deleting it will leave them in your cloud provider, but Spacelift will stop tracking
          them.
        </Banner>
      )}
    </DeleteConfirmationModal>
  );
});

export const showIntentProjectDeleteConfirmation = (props: IntentProjectDeleteConfirmationProps) =>
  show(IntentProjectDeleteConfirmation, props);
